export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9765.889235dc.jpg";